/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/frame_dome': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M8.5 32H0v-8.5h1V31h7.5zM14.269 31h3.461v1h-3.461zM32 32h-8.5v-1H31v-7.5h1zM31 14.27h1v3.461h-1zM32 8.5h-1V1h-7.5V0H32zM14.27 0h3.461v1H14.27zM1 8.5H0V0h8.5v1H1zM0 14.269h1v3.461H0z"/>'
  }
})
